// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"fR-z","inlineTitle":"gR-z","sponsoredAdsWrapper":"hR-z","marketplaceRecosWrapper":"iR-z"};